import { render, staticRenderFns } from "./BusyPassEducationModal.vue?vue&type=template&id=a3c6fe84&scoped=true"
import script from "./BusyPassEducationModal.vue?vue&type=script&lang=js"
export * from "./BusyPassEducationModal.vue?vue&type=script&lang=js"
import style0 from "./BusyPassEducationModal.vue?vue&type=style&index=0&id=a3c6fe84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3c6fe84",
  null
  
)

export default component.exports